RivalIQ.apps.Admin.apps.Account.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.UserSearchResult = Marionette.ItemView.extend({
        template: '#adminUserItemTemplate',
        tagName: 'tr',

        ui: {
            edit: '.x-edit',
            actions: '.x-actions'
        },

        events: {
            'click @ui.edit': 'edit',
            'click @ui.actions': 'actions'
        },

        modelEvents: {
            'change': 'render'
        },

        templateHelpers: function () {

            const me = this;
            const model = me.model;

            return {
                plan: RivalIQ.state.product.getPlanById(model.get('account').plan_id),
                accountConversionStatus: _.find(RivalIQ.enums.account.conversionStatuses, {
                    id: model.get('account').account_conversion_status_id
                }).name,
                role: _.find(RivalIQ.enums.roles, {
                    id: model.get('role_id')
                }),
                userStatus: _.find(RivalIQ.enums.user.status, {
                    id: model.get('account_user_status_id')
                }).name,
                accountStatus: _.find(RivalIQ.enums.account.statuses, {
                    id: model.getAccount().get('account_status_id')
                }).name,
                accountEnabled: model.getAccount().get('enabled'),
                lastActive: (model.get('last_activity_at') ? moment(model.get('last_activity_at')).fromNow() : null)
            };
        },

        onRender: function () {
            const me = this;
            if (me.model.get('account_user_status_id') === 2 || !me.model.getAccount().get('enabled')) {
                me.el.style.backgroundColor = '#f8f1f1';
            }
        },

        behaviors: {
            ImpersonateAction: {
                behaviorClass: RivalIQ.apps.Admin.behaviors.ImpersonateAction
            }
        },

        getImpersonationEmail: function () {
            const me = this;
            return me.model.get('email');
        },

        getAccountStatus: function () {
            const me = this;
            return me.model.get('account').account_status_id;
        },

        getAccountUserStatus: function () {
            const me = this;
            return me.model.get('account_user_status_id');
        },

        edit: function () {
            const me = this;

            RivalIQ.execute('show:modal', new views.Edit({
                model: me.model,
                selectorProperties: me.options.adminEditingProperties
            }));
        },

        actions: function () {
            const me = this;

            RivalIQ.execute('show:modal', new views.Actions({
                model: me.model
            }));
        }
    });
});
